export default __webpack_public_path__ + "static/naves_1-bdd055ede076cd8d6c7e4ac3b721c673.jpg";